
if (!customElements.get('prink-cart-complement')) {
  customElements.define('prink-cart-complement', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-add], [data-add-all]');
        if (!button || !this.contains(button)) return;
        if (this.busy) return;
        this.busy = true;
        const buttons = this.querySelectorAll('[data-add], [data-add-all]');
        const status = this.querySelector('[role="status"]');
        const drawer = this.closest('cart-drawer');
        buttons.forEach(item => { item.disabled = true; });
        status.textContent = 'Añadiendo…';
        const rec = window.PrinkRecommendations;
        const recContext = rec?.context(button.hasAttribute('data-add-all') ? 'missing_colours' : this.dataset.recSource,this.dataset.recFamily,drawer?'cart_drawer':'cart_page');
        const items = button.hasAttribute('data-add-all') ? JSON.parse(button.dataset.items) : [{id:this.dataset.variant,quantity:1}];
        try {
          const options = {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items,...(drawer?{sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:window.location.pathname}:{})})
          };
          const response = await (rec ? rec.fetchAdd(window.routes.cart_add_url,options,recContext,items) : fetch(window.routes.cart_add_url,options));
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || 'No se han podido añadir los consumibles.');
          if (!drawer) { window.location.reload(); return; }
          drawer.renderContents(data);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'prink-cart-complement',cartData:data});
        } catch(error) {
          rec?.emit('error',recContext,items);
          if(!drawer){status.textContent='Revisa las cantidades del carrito antes de volver a intentarlo.';button.disabled=true;return;}
          // A multi-item request can partially succeed when stock changes. Refresh before another attempt.
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
            const refreshed = await fetch(url, {headers:{'Accept':'application/json'}});
            if (refreshed.ok) drawer.renderContents({sections:await refreshed.json()});
          } catch (_) { /* Keep the current cart and its readable error. */ }
          const errorTarget = drawer.querySelector('.pw-cart-complement__status') || drawer.querySelector('[id$="CartErrors"]') || status;
          errorTarget.textContent = (error.message || 'No se ha podido añadir.') + ' Revisa las cantidades del carrito antes de volver a intentarlo.';
          buttons.forEach(item => { item.disabled = false; });
          this.busy = false;
        }
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

